<template>
  <div id="aboutOfme" class="about-container">
    <div id="about_left" class="animated fadeInDown" style="animation-duration: 3s">
      <p>山西富垦电气有限责任公司</p>
      <p><span class="fa fa-map-marker"></span>&nbsp;地址：太原晋源区姚村镇洞儿沟村西仁线备战路1号（七苦山对面）</p>
      <p><span class="fa fa-user-o"></span>&nbsp;联系人：赵先生</p>
      <p><span class="fa fa-phone"></span>&nbsp;电话：400-9669918 <br><span class="fa fa-wechat">&nbsp;</span>微信同号：13935137090 18536889888</p>
      <p><span class="fa fa-envelope-open-o"></span>&nbsp;邮箱：shanxifuken@163.com</p>
    </div>
    <div id="about_right" class="animated fadeInUp" style="animation-duration: 3s">
      <!-- 用于显示百度地图的容器 -->
      <div id="baidu-map" style="width: 90%; height: 400px;"></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

// 百度地图 API 的 AK
const AK = '0X4KwHqmVnk8wwNco8Bd1v8SIxJzyYsf';

onMounted(() => {
  // 创建地图实例
  const map = new BMap.Map("baidu-map", {
    coordsType: BMAP_COORD_BD09, // 添加逗号
    // coordsType指定输入输出的坐标类型，BMAP_COORD_GCJ02为gcj02坐标，BMAP_COORD_BD09为bd0ll坐标，默认为BMAP_COORD_BD09。
    // 指定完成后API将以指定的坐标类型处理您传入的坐标
  });
  const point = new BMap.Point(112.378997, 37.658006); // 创建点坐标
  map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别
  map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
  map.addControl(new BMap.NavigationControl());
  map.addControl(new BMap.ScaleControl());
  map.addControl(new BMap.OverviewMapControl());
  map.addControl(new BMap.MapTypeControl());
  map.setCurrentCity("太原"); // 仅当设置城市信息时，MapTypeControl的切换功能才能可用
  map.centerAndZoom(point, 15);    
  var marker = new BMap.Marker(point);        // 创建标注    
  map.addOverlay(marker); 
  var opts = {    
    width : 150,     // 信息窗口宽度    
    height: 80,     // 信息窗口高度    
    title : "山西富垦电气有限责任公司"  // 信息窗口标题   
  }    
  var infoWindow = new BMap.InfoWindow("洞儿沟村委会西南侧190米", opts);  // 创建信息窗口对象    
  map.openInfoWindow(infoWindow, map.getCenter());      // 打开信息窗口
});

onUnmounted(() => {
  // 可以在这里进行一些清理操作，如移除事件监听器等
  // 目前暂时没有额外操作
});
</script>

<style scoped>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 关于我们容器样式 */
.about-container {
  background: url("../static/images/bg_body4.jpeg") no-repeat center center;
  background-size: cover;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px;
  min-height: 100vh; /* 确保容器至少占满整个视口高度 */
}

/* 左侧信息区域样式 */
#about_left {
  font-size: 24px;
  font-weight: bold;
  width: 45%;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.3); /* 添加半透明背景 */
  border-radius: 10px; /* 添加圆角 */
}

#about_left p {
  margin-bottom: 15px;
}

/* 右侧地图区域样式 */
#about_right {
  width: 45%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#baidu-map {
  width: 100%;
  height: 500px;
  border-radius: 10px; /* 添加圆角 */
  overflow: hidden; /* 确保圆角生效 */
}

/* 媒体查询，调整不同屏幕尺寸下的样式 */
@media (max-width: 768px) {
  .about-container {
    flex-direction: column;
    padding: 30px;
  }

  #about_left,
  #about_right {
    width: 100%;
    margin-bottom: 30px;
  }

  #about_left {
    font-size: 20px;
  }
}
</style>